define('FooterCopyright.View', [
    'footer_copyright.tpl',
    'SC.Configuration',
    'Backbone'
], function FooterCopyrightView(
    footerCopyrightTpl,
    Configuration,
    Backbone
) {
    return Backbone.View.extend({
        template: footerCopyrightTpl,
        getContext: function getContext() {
            return {
                copyrightText: (Configuration.get('footer.copyrightText') || '').replace('[YEAR]', new Date().getFullYear())
            };
        }
    });
});
